import { BrowserRouter, Link } from 'react-router-dom'
import { AppRoutes } from './router'
import CookieConsent from 'react-cookie-consent'


function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
      <CookieConsent
        location="bottom"
        buttonText="Acceptér"
        declineButtonText="Afvis"
        enableDeclineButton
        cookieName="hesteshop_cookie_consent"
        style={{ 
          background: "#2B373B",
          fontSize: "14px",
          padding: "15px"
        }}
        buttonStyle={{ 
          background: "#10B981",
          color: "#fff",
          fontSize: "14px",
          padding: "10px 30px",
          borderRadius: "5px",
          fontWeight: "600"
        }}
        declineButtonStyle={{
          background: "#6B7280",
          color: "#fff",
          fontSize: "14px",
          padding: "10px 30px",
          borderRadius: "5px",
          fontWeight: "600"
        }}
        expires={150}
      >
        Denne hjemmeside bruger cookies for at forbedre brugeroplevelsen og analysere trafik. 
        Ved at klikke "Acceptér" accepterer du vores brug af cookies.{" "}
        <Link to="/privacy" style={{ color: "#10B981", textDecoration: "underline" }}>
          Læs mere
        </Link>
      </CookieConsent>
    </BrowserRouter>
  )
}

export default App